/**
 * Available Google Font options for store customization.
 *
 * @type {Array<{value: string, label: string, category: string}>}
 */
export const FONT_OPTIONS = [
    { value: 'Inter', label: 'Inter', category: 'Sans-serif' },
    { value: 'Poppins', label: 'Poppins', category: 'Sans-serif' },
    { value: 'Playfair Display', label: 'Playfair Display', category: 'Serif' },
    { value: 'Lato', label: 'Lato', category: 'Sans-serif' },
]

const BUNDLED_FONTS = ['Roboto Variable']
const FONT_WEIGHTS = '400;500;700'

/**
 * Dynamically loads a Google Font by injecting a link element into the document head.
 * Idempotent - calling multiple times for the same font is a no-op.
 * Skips bundled fonts (Roboto Variable) and null/undefined values.
 *
 * @param {string|null} fontName - The Google Font name to load
 */
export const loadGoogleFont = (fontName) => {
    if (!fontName || BUNDLED_FONTS.includes(fontName)) {
        return
    }

    const existingLink = document.querySelector(`link[data-google-font="${CSS.escape(fontName)}"]`)
    if (existingLink) {
        return
    }

    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontName)}:wght@${FONT_WEIGHTS}&display=swap`
    link.setAttribute('data-google-font', fontName)
    document.head.appendChild(link)
}
